export enum QueryKeys {
  SKINS = "skins-query",
  SKIN_DETAIL = "skin-detail-query",
  SKIN_ATTRIBUTES = "skin-attributes-query",
  TASKS_QUERY = "tasks-query",
  ALEA_TEAM_TASKS = "alea-tasks-query",
  INTEGRATOR_SETUP_CURRENCIES = "integrator-setup-currencies-query",
  GAMES_QUERY = "games-query",
  GAMES_LIST_QUERY = "games-list-query",
  USERS = "users-query",
  CASINO_JURISDICTIONS = "casino-jurisdictions",
  CASINO_JURISDICTIONS_INTEGRATORS = "casino-jurisdictions-integrators",
  CASINO_JURISDICTIONS_SOFTWARE = "casino-jurisdictions-software",
  GAMES_CATEGORIES = "games-categories-query",
  COUNTRIES_QUERY = "countries-query",
  SESSION_HISTORY = "session-history-query",
  SESSION_DETAILS = "session-details-query",
  SESSION_ACTION_TRACES = "session-action-traces-query",
  ROUND_ACTION_TRACES = "round-action-traces-query",
  ROUND_DETAILS = "round-details-query",
  ROUND_HISTORY = "round-history-query",
  SESSION_ACTION_DETAIL_HTTP_TRACES = "session-action-detail-http-traces",
  CONFIGURATIONS_TEST = "configuration-test-query",
  GAME_DETAIL = "game-detail-query",
  GAME_ROLLOUTS = "game-rollouts-query",
  GAME_ROLLOUTS_FROM_DETAILS = "game-rollouts-from-details-query",
  PLAYER_CHECK_SEARCH = "player-check-search",
  PLAYER_CHECK_DETAILS = "player-check-details",
  PLAYER_CHECK_RECENT_SESSIONS = "player-check-recent-sessions",
  PLAYER_CHECK_DETAILS_WALLETS = "player-check-details-wallets",
  GAME_CONFIGURATIONS_LIST = "game-configurations-query",
  GAMES_TAB = "games-tab-query",
  CASINOS = "casinos-query",
  SOFTWARE = "software-query",
  SOFTWARE_RTP = "software-rtp",
  SKIN_RTP = "skin-rtp",
  SOFTWATE_DETAIL = "software-detail-query",
  SETUP_CONFIGURATIONS = "setup-configurations-query",
  SMART_TRANSACTION_REPORT = "smart-transaction-report-query",
  MARKETS = "markets-query",
  MARKET_DETAIL = "market-detail-query",
  MARKET_ASSIGNED_JURISDICTIONS = "assigned-jurisdictions",
  MARKET_UNASSIGNED_JURISDICTIONS = "unassigned-jurisdictions",
  SKIN_BET_LIMITS = "skin-bet-limits-query",
  INVOICE_CATEGORIES = "invoice-categories-query",
}
// Add new query key here
